import {ENV} from '../../configs/env.enum';
import {Product} from './product.interface';
import {PRODUCTS} from './products.enum';

export const BASE_PRODUCTS: {[key in PRODUCTS]: Product} = {
  Opplevelser: {
    key: PRODUCTS.Opplevelser,
    id: 1,
    name: 'Opplevelser',
    productUrl: 'https://opplevelser.vilmer.no/',
  },
  MinMemoria: {
    key: PRODUCTS.MinMemoria,
    id: 2,
    name: 'MinMemoria',
    productUrl: 'https://minmemoria.vilmer.no/',
  },
  DigitaleOpplevelser: {
    key: PRODUCTS.DigitaleOpplevelser,
    id: 3,
    name: 'Digitale Opplevelser',
    productUrl: 'https://digitaleopplevelser.vilmer.no/',
  },
  Triggo: {
    key: PRODUCTS.Triggo,
    id: 4,
    name: 'Triggo',
    productUrl: 'https://vilmer.no/',
  },
  VR: {
    key: PRODUCTS.VR,
    id: 8,
    name: 'VR',
    productUrl: 'https://vilmer.no/',
  },
  Yetitablet: {
    key: PRODUCTS.Yetitablet,
    id: 9,
    name: 'Yetitablet',
    productUrl: 'https://vilmer.no/',
  },
  CatalogOfIdeas: {
    key: PRODUCTS.CatalogOfIdeas,
    id: 10,
    name: 'The Catalog Of Ideas',
    productUrl: 'https://vilmer.no/',
  },
  Friskus: {
    key: PRODUCTS.Friskus,
    id: 11,
    name: 'Friskus',
    productUrl: 'https://vilmer.no/',
  },
  Dashboard: {
    key: PRODUCTS.Dashboard,
    id: 12,
    name: 'Dashboard',
    productUrl: 'https://dashboard.vilmer.no/',
  },
};

const ENV_PRODUCTS: {[key in PRODUCTS]: {[key in ENV]: Product}} = {
  Opplevelser: {
    development: {
      ...BASE_PRODUCTS.Opplevelser,
    },
    stage: {
      ...BASE_PRODUCTS.Opplevelser,
      productUrl: 'https://opplevelser-stage.vilmer.no/',
    },
    production: {
      ...BASE_PRODUCTS.Opplevelser,
    },
  },
  MinMemoria: {
    development: {
      ...BASE_PRODUCTS.MinMemoria,
    },
    stage: {
      ...BASE_PRODUCTS.MinMemoria,
      productUrl: 'https://stage-minmemoria.vilmer.no/',
    },
    production: {
      ...BASE_PRODUCTS.MinMemoria,
    },
  },
  DigitaleOpplevelser: {
    development: {
      ...BASE_PRODUCTS.DigitaleOpplevelser,
    },
    stage: {
      ...BASE_PRODUCTS.DigitaleOpplevelser,
      productUrl: 'https://digitaleopplevelser-stage.vilmer.no/',
    },
    production: {
      ...BASE_PRODUCTS.DigitaleOpplevelser,
    },
  },
  Triggo: {
    development: {
      ...BASE_PRODUCTS.Triggo,
    },
    stage: {
      ...BASE_PRODUCTS.Triggo,
    },
    production: {
      ...BASE_PRODUCTS.Triggo,
    },
  },
  VR: {
    development: {
      ...BASE_PRODUCTS.VR,
    },
    stage: {
      ...BASE_PRODUCTS.VR,
    },
    production: {
      ...BASE_PRODUCTS.VR,
    },
  },
  Yetitablet: {
    development: {
      ...BASE_PRODUCTS.Yetitablet,
    },
    stage: {
      ...BASE_PRODUCTS.Yetitablet,
    },
    production: {
      ...BASE_PRODUCTS.Yetitablet,
    },
  },
  CatalogOfIdeas: {
    development: {
      ...BASE_PRODUCTS.CatalogOfIdeas,
    },
    stage: {
      ...BASE_PRODUCTS.CatalogOfIdeas,
    },
    production: {
      ...BASE_PRODUCTS.CatalogOfIdeas,
    },
  },
  Friskus: {
    development: {
      ...BASE_PRODUCTS.Friskus,
    },
    stage: {
      ...BASE_PRODUCTS.Friskus,
    },
    production: {
      ...BASE_PRODUCTS.Friskus,
    },
  },
  Dashboard: {
    development: {
      ...BASE_PRODUCTS.Dashboard,
      productUrl: 'http://dashboard.vilmer.local/',
    },
    stage: {
      ...BASE_PRODUCTS.Dashboard,
      productUrl: 'https://dashboard-stage.vilmer.no/',
    },
    production: {
      ...BASE_PRODUCTS.Dashboard,
      productUrl: 'https://dashboard.vilmer.no/',
    },
  },
};

export const getProduct = (productKey: PRODUCTS): Product => {
  const env = (process.env['REACT_APP_ENVIRONMENT'] as ENV) || ENV.stage;
  const product = ENV_PRODUCTS[productKey]?.[env] || undefined;

  if (!product) {
    throw new Error(`Product ${productKey} not found`);
  }

  return product;
};

export const getProductIds = (): number[] => {
  return Object.keys(BASE_PRODUCTS).map(key => getProduct(key as PRODUCTS).id);
};

export const getProductUrl = (product: PRODUCTS): string => {
  const productValue = getProduct(product);

  return productValue.productUrl || '';
};

export const getProductById = (productId: number): Product => {
  const productKey = Object.keys(BASE_PRODUCTS).find(key => {
    const product = getProduct(key as PRODUCTS);

    return product.id === productId;
  });

  return getProduct(productKey as PRODUCTS)!;
};
